import { UseFormRegisterReturn } from 'react-hook-form';

import { FieldErrorMessage } from 'components/Form/FieldErrorMessage/FieldErrorMessage';

import s from './RadioButtons.module.css';

type option = {
  label: string;
  value: number | string;
};

type TProps = {
  options: option[];
  register?: UseFormRegisterReturn;
  required?: boolean;
  error?: string;
  id: string;
};

export const RadioButtons = ({
  options,
  register,
  required,
  error,
  id,
  ...props
}: TProps) => {
  return (
    <fieldset className={s.root}>
      {options.map((giftCard) => {
        return (
          <div key={giftCard.label} className={s.radioButton}>
            <input
              type="radio"
              required={required}
              id={giftCard.label}
              {...register}
              {...props}
              value={giftCard.value}
            />
            <label
              key={giftCard.value}
              className={s.valueButton}
              htmlFor={giftCard.label}
            >
              {giftCard.label}
            </label>
          </div>
        );
      })}
      {error && (
        <FieldErrorMessage errorClassName={s.error} id={id} error={error} />
      )}
    </fieldset>
  );
};
